import {createNavigation} from 'next-intl/navigation';
import {defineRouting} from 'next-intl/routing';

export const routing = defineRouting({
  locales : ['en', 'fr'  ,'es' , 'pt-BR' , 'zh-CN'],
  defaultLocale: 'en',
  localeDetection:false,
  localeCookie: {
    // Custom cookie name
    name: 'USER_PREFERRED_LANG',
    path: '/',
    // Expire in one week
    maxAge: 60 * 60 * 24 * 7,
    sameSite: 'lax',
    domain: '.rolzo.com',
    secure:true,
  },
  localePrefix: {
    mode: 'always',
    prefixes: {
      'pt-BR': '/pt',
    }
  },
  pathnames: {
      // routes translation to be made here if needed in the future , below example can be followed
    // '/': {
    //   en: '/',
    //   fr: '/',
    //   es: '/'
    // },
    // '/services/chauffeur-services': {
    //   en: '/services/chauffeur-services',
    //   fr: '/services/chauffeur-services',
    //   es: '/services/chauffeur-services'
    // },
    // '/services/vip-meet-greet': {
    //   en: '/services/vip-meet-greet',
    //   fr: '/services/vip-meet-greet',
    //   es: '/services/vip-meet-greet'
    // },
  }
});


export const {Link, getPathname, redirect, usePathname, useRouter} =
  createNavigation(routing);